<div class="fixed bottom-5 right-5 z-[9999] flex flex-col-reverse gap-2.5">
  @for (toast of toasts(); track toast.id) {
    <div
      class="flex items-center gap-3 px-5 py-3 rounded-lg text-white font-inherit cursor-pointer min-w-70 transition-opacity duration-200 animate-[toast-slide-in_0.3s_ease-out]"
      [style.backgroundColor]="'var(--color-snackbar-' + toast.type + ')'"
      [class.opacity-0]="toastToRemove().has(toast.id)"
      (click)="remove(toast.id)">
      <svg *ngIf="toast.type === 'success'" class="w-5 h-5 shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="12" cy="12" r="10"></circle>
        <path d="M9 12l2 2 4-4"></path>
      </svg>
      <svg *ngIf="toast.type === 'error'" class="w-5 h-5 shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="12" cy="12" r="10"></circle>
        <line x1="15" y1="9" x2="9" y2="15"></line>
        <line x1="9" y1="9" x2="15" y2="15"></line>
      </svg>
      <svg *ngIf="toast.type === 'info'" class="w-5 h-5 shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="12" cy="12" r="10"></circle>
        <line x1="12" y1="16" x2="12" y2="12"></line>
        <line x1="12" y1="8" x2="12.01" y2="8"></line>
      </svg>
      <svg *ngIf="toast.type === 'warning'" class="w-5 h-5 shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
        <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
        <line x1="12" y1="9" x2="12" y2="13"></line>
        <line x1="12" y1="17" x2="12.01" y2="17"></line>
      </svg>
      <span>{{ toast.message }}</span>
    </div>
  }
</div>
